import styled from "styled-components";
import { palette } from "styled-theme";

const CalenderWrapper = styled.div`
  background: #ffffff;
  padding: 20px;
  .calenderContainer {
    height: calc(100vh - 260px);
    display: flex;
  }
  .periodsCalenderContainer {
    height: calc(90vh - 438px);
    display: flex;
  }
  .rbc-event {
    background-color: ${palette("primary", 0)};
  }
  .rbc-allday-cell {
    display: none;
  }
  .rbc-time-header .rbc-label {
    width: 49.1641px;
    min-width: 49.1641px;
    max-width: 49.1641px;
  }
`;

export default CalenderWrapper;
